import React, { useState, useEffect } from "react";
import "../../styles/TrainerNoteModal.css";

const TrainerNoteModal = ({ isOpen, onClose, onSave, initialContent = "", isEditing = false }) => {
    const [noteContent, setNoteContent] = useState(initialContent);
    const [errors, setErrors] = useState({});

    // Reset input when modal opens
    useEffect(() => {
        if (isOpen) {
            setNoteContent(initialContent);
            setErrors({});
        }
    }, [isOpen, initialContent]);

    if (!isOpen) return null; // Don't render if modal is closed

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!noteContent.trim()) {
            setErrors({ noteContent: "Notatka nie może być pusta" });
            return;
        }

        onSave(noteContent);
        setNoteContent(""); // Reset after save
        setErrors({});
    };

    const handleCancel = () => {
        setNoteContent("");
        setErrors({});
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleCancel();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content">
                <h2>{isEditing ? "Edytuj notatkę" : "Dodaj notatkę"}</h2>
                <form onSubmit={handleSubmit}>
                    <textarea
                        placeholder="Wpisz notatkę..."
                        value={noteContent}
                        onChange={(e) => setNoteContent(e.target.value)}
                    />
                    {errors.noteContent && (
                        <span className="error">{errors.noteContent}</span>
                    )}
                    <div className="modal-buttons">
                        <button
                            type="button"
                            className="trainerNote__cancelButton"
                            onClick={handleCancel}
                        >
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className="trainerNote__saveButton"
                        >
                            Zapisz
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TrainerNoteModal;